import styles from "./pro_feature_check.module.scss"
import { captureException } from "@sentry/react"

interface Props {
  billingUrl: string
  creditsBenefits?: string[] | null
  expirationDate: string
  maxFreeApplets: number
  moveNextView: () => void
  tierName: string
}

const noteAboutAppletLimit = (maxFreeApplets: number) => {
  if (maxFreeApplets == -1) return ""
  if (maxFreeApplets == 2) return ", which is limited to two Applets only"

  captureException(`Applet quota translation error. Provided ${maxFreeApplets} but translation is missing`)
  return ""
}

const ProFeatureCheck = ({ billingUrl, creditsBenefits, expirationDate, maxFreeApplets, moveNextView, tierName }: Props) => {
  const proFeatures = [
    "Use multiple actions to do more per Applet",
    "Get faster and more reliable Applet runs",
    "Access exclusive services like Webhooks, RSS Feeds, and more",
    "Create and manage up to 20 Applets",
  ]

  const proPlusFeatures = [
    "Use multiple actions to do more per Applet",
    "Get faster and more reliable Applet runs",
    "Access exclusive services like Webhooks, RSS Feeds, and more",
    "Create and manage unlimited Applets",
    "Use filters, queries, and AI services",
  ]

  const features = creditsBenefits ?? (tierName === "Pro+" ? proPlusFeatures : proFeatures)

  return (
    <div className={styles.pro_feature_check}>
      <h1 className="mb2--phone mb2--small-phone">Cancel {tierName}</h1>

      {/* Wrapper keeps the p out of the legacy `section > div > p` 550px clamp
          that the other cancellation steps still rely on. */}
      <div className={styles.description}>
        <p>
          On {expirationDate} you will be moved to our free plan{noteAboutAppletLimit(maxFreeApplets)}. If you continue
          with cancellation, you will lose access to all subscription benefits and any future subscriptions will be at
          our latest pricing.
        </p>
      </div>

      {features.length > 0 && (
        <div className={styles.feature_card}>
          <p className={styles.feature_card_title}>You will lose access to these {tierName} features:</p>
          <ul className={styles.feature_list}>
            {features.map(feature => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>
      )}

      <div className={styles.ctas}>
        <a className="button-secondary" href={billingUrl}>
          Stay {tierName}
        </a>
        <button type="button" className="button-secondary button-outlined" onClick={moveNextView}>
          Continue cancellation
        </button>
      </div>
    </div>
  )
}

export default ProFeatureCheck
